import { useEffect, useState } from 'react'

/** Milliseconds left until `deadline` (ISO string), refreshed every second. */
export const useCountdown = (deadline: string | null | undefined): number => {
  const target = deadline ? new Date(deadline).getTime() : 0
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (!target) return undefined
    setNow(Date.now())
    const timer = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(timer)
  }, [target])
  return target ? Math.max(0, target - now) : 0
}
